import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getReceiptOCR,
  skipOCRProcess,
  incrementOCRRequestCount,
} from "../../actions/claimActionsPP";
import Modal from "react-modal";
import { Button, Card, CardSection } from "cxa-components";
import messages from "components/messagesDescription";

const ReceiptProcessingLoader = ({ receipt, intl, match}) => {
  const [isOpen, setOpen] = useState(false);
  const data = useSelector(state => state.claimsPP);
  const dispatch = useDispatch();
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (data.ocrRequestCount % 10000 === 2) {
        setOpen(true);
      } else {
        dispatch(getReceiptOCR(receipt.objectId, match.params.selectedDelegator));
        dispatch(incrementOCRRequestCount());
      }
    }, 5000);

    return () => {
      clearTimeout(timeout);
    };
  }, [data.ocrRequestCount]);


  const skipOCR = () => {
    dispatch(skipOCRProcess());
    setOpen(false);
  };

  return (
    <div className="receipt-processing-loader">
      <Modal isOpen={isOpen} className="popup" overlayClassName="popup__overlay" closeTimeoutMS={0}>
        <Card style={{ margin: "20px" }}>
          <CardSection>
            <p>
              <strong> {intl.formatMessage(messages.claims.receiptProcessLongMsg1)}</strong>
            </p>
            <p>
              <strong>{intl.formatMessage(messages.claims.receiptProcessLongMsg2)}</strong>
            </p>
            <p>
              <strong> {intl.formatMessage(messages.claims.receiptProcessLongMsg3)}</strong>
            </p>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <Button primary type="button" onClick={skipOCR}>
                {intl.formatMessage(messages.continueDescription)}
              </Button>
            </div>
          </CardSection>
        </Card>
      </Modal>
      <div>
        <span className="text-loader">
          <strong>{intl.formatMessage(messages.claims.receiptProcessLoadMsg)}</strong>
        </span>
      </div>
      <div>
        <img src="/assets/images/receipt-processing-loader.gif" alt="" />
      </div>
    </div>
  );
};

ReceiptProcessingLoader.propTypes = {
  className: PropTypes.string,
};

export default ReceiptProcessingLoader;



// WEBPACK FOOTER //
// ./components/claim/ReceiptProcessingLoader.js